module.exports = __webpack_public_path__ + "img/logoresponsive.2b29f90b.png";